import * as React from 'react';

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

type CircularProgressProps = React.ComponentProps<typeof CircularProgress>;

type Props = CircularProgressProps & {
  loading: boolean;
};

export default function CustomLoading(props: Props): JSX.Element {
  const { loading, ...rest } = props;

  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: 2000,
      }}
      open={loading}
    >
      <CircularProgress
        sx={{
          color: 'white',
          left: '50%',
          position: 'absolute',
          top: '50%',
          zIndex: 2000,
        }}
        {...rest}
      />
    </Backdrop>
  );
}
